var getFileNameByImageUrl = function (imageUrl) {
    var parts = imageUrl.split('/');
    var fileName = parts[parts.length - 1];
    return fileName || '';
};
export var fill = function (imageUrl, width, height) {
    var fileName = getFileNameByImageUrl(imageUrl);
    return "".concat(imageUrl, "/v1/fill/w_").concat(width, ",h_").concat(height, "/").concat(fileName);
};
export var fit = function (imageUrl, width, height) {
    var fileName = getFileNameByImageUrl(imageUrl);
    return "".concat(imageUrl, "/v1/fit/w_").concat(width, ",h_").concat(height, "/").concat(fileName);
};
export var crop = function (imageUrl, x, y, width, height) {
    var fileName = getFileNameByImageUrl(imageUrl);
    return "".concat(imageUrl, "/v1/crop/x_").concat(x, ",y_").concat(y, ",w_").concat(width, ",h_").concat(height, "/").concat(fileName);
};
//# sourceMappingURL=resizeImage.js.map